module.exports = __webpack_public_path__ + "fonts/AftaSansThin-Regular.33e1760d.woff";